import el from "@cypherpotato/el";

export function Icon(name, ...args) {
    return el("i",
        {
            classList: `ri-${name}`
        },
        ...args
    );
}

export function IconFrame(...args) {
    return el("span.icon-frame", ...args);
}